var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 1428 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-Us---Desktop-V3",
    transform: "translate(-12.000000, -487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero",
    transform: "translate(0.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wavoMatic",
    transform: "translate(0.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,128.25 C91.4988064,174.083333 217.745095,197 390.738867,197 C650.229525,197 779.268804,131.916667 968.006304,120 C1093.8313,112.055556 1254.49587,129.605413 1450,172.649573 L1450,43 L12,43 L12,128.25 Z",
    id: "Path",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    transform: "translate(731.000000, 120.000000) scale(1, -1) translate(-731.000000, -120.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.783937b3e5cee79fe5e95e322867f881.svg";
export { ForwardRef as ReactComponent };